import * as React from 'react';
import { Flex, Box, Heading, Container } from '@qga/roo-ui/components';
import styled from '@emotion/styled';

import theme from 'styles/theme';
import BookingSummary from 'components/BookingSummary';
import PropertyImage from 'components/PropertyImage';

import ShowOnSmallScreen from '../ShowOnSmallScreen';
import ShowOnLargeScreen from '../ShowOnLargeScreen';
import { useDetailsBooking } from 'lib/hooks';

const sidePanelWidth = ['100%', '34%', theme.minWidths.sidebar];

const GrowContainer = styled(Container)`
  flex-grow: 1;
`;

interface TwoColumnWithBookingSummaryProps {
  heading: React.ReactNode;
  showSummaryOnMobile?: boolean;
}

const TwoColumnWithBookingSummary: React.FC<TwoColumnWithBookingSummaryProps> = ({ children, heading, showSummaryOnMobile = false }) => {
  const { booking } = useDetailsBooking();
  const bookingSummary = <BookingSummary booking={booking} />;

  return (
    <GrowContainer mt={[4, 12]} mb={[7, 8]}>
      <Flex flexDirection={['column', 'row']}>
        <Box flex="1">
          <Heading.h2 fontSize={['xl', '3xl']} mb={[4, 2]} fontWeight="normal">
            {heading}
          </Heading.h2>
          {showSummaryOnMobile && <ShowOnSmallScreen>{bookingSummary}</ShowOnSmallScreen>}
          {children}
        </Box>
        <ShowOnLargeScreen>
          <Box width={sidePanelWidth} ml={[0, 5, 24]}>
            <PropertyImage display={['none', 'block']} mb={2} ratio="50%" {...booking.largeImage} />
            {bookingSummary}
          </Box>
        </ShowOnLargeScreen>
      </Flex>
    </GrowContainer>
  );
};

export default TwoColumnWithBookingSummary;
